import { Link } from "react-router-dom";
import type { Article } from "@/types/content";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import SkeletonGrid from "@/components/feature/SkeletonGrid";
import EmptyState from "@/components/feature/EmptyState";

interface LatestSectionProps {
  articles: Article[];
  loading: boolean;
}

export default function LatestSection({ articles, loading }: LatestSectionProps) {
  return (
    <section aria-label="最新原创文章" className="animate-fade-up">
      <SectionHeading
        eyebrow="Original · 最新原创"
        title="刚刚发布的深度内容"
        description="每一篇都经过选题、采访与编辑流程，拒绝搬运与拼凑。"
        action={
          <Link
            to="/search?q=内容"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览全部原创
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />
      {loading ? (
        <SkeletonGrid count={6} columns="sm:grid-cols-2 lg:grid-cols-3" />
      ) : articles.length === 0 ? (
        <EmptyState
          icon="ri-article-line"
          title="暂无最新内容，敬请期待"
          description="编辑团队正在准备下一批原创报道，你可以先浏览热门视频与专题合集。"
        />
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      )}
    </section>
  );
}